import { z } from "zod";
import { ProductCodeSchema } from "../billing";
import { WorkspaceIpSettings } from "./workspace";
import { nullishToOptional } from "../helpers";

export const WorkspaceContext = z.object({
  workspaceId: z.string(),
  product: ProductCodeSchema,
  ipWhitelist: nullishToOptional(WorkspaceIpSettings),
  publicDesignSystem: z.boolean().optional(),
});

export type WorkspaceContext = z.infer<typeof WorkspaceContext>;
